import americanExpress from './card-amex.svg';
import maestro from './card-maestro.svg';
import mastercard from './card-mastercard.svg';
import paypal from './card-paypal.svg';
import visa from './card-visa.svg';
import check from './check.svg';
import edit from './edit.svg';
import email from './email.svg';
import heartBlue from './heart-blue.png';
import heartRed from './heart-red.png';
import lock from './lock.svg';
import logo from './logo.svg';
import successful from './logo.svg';
import successfulMobile from './logo.svg';
import checkoutSuccess from './logo.svg';
import checkoutSuccessMobile from './logo.svg';
import verifyEmail from './logo.svg';
import verifyEmailMobile from './logo.svg';
import aol from './mail-aol.svg';
import gmail from './mail-gmail.svg';
import gmx from './mail-gmx.svg';
import hey from './mail-hey.svg';
import icloud from './mail-icloud.svg';
import outlook from './mail-outlook.svg';
import protonmail from './mail-protonmail.svg';
import yahoo from './mail-yahoo.svg';
import yandex from './mail-yandex.svg';
import zoho from './mail-zoho.svg';
/*Plans*/
import plan_0 from './plan-size-0.svg';
import plan_basic from './plan-size-0.svg';
import plan_1 from './plan-size-1.svg';
import plan_standard from './plan-size-1.svg';
import plan_2 from './plan-size-2.svg';
import plan_3 from './plan-size-2.svg';
import plan_premium from './plan-size-2.svg';
import ResendEmailLoader from './resend-email-loader.svg';
import apple from './social-apple.svg';
import facebook from './social-facebook.svg';
import google from './social-google.svg';

// Looked up by dynamic keys in places, so a missing image is `undefined` rather than a type error
export const images: Record<string, string | undefined> = {
  logo,

  successful,
  successfulMobile,

  checkoutSuccess,
  checkoutSuccessMobile,

  verifyEmail,
  verifyEmailMobile,

  gmail,
  outlook,
  yahoo,
  protonmail,
  aol,
  zoho,
  icloud,
  gmx,
  hey,
  yandex,
  google,
  facebook,
  email,
  lock,
  apple,

  edit,
  check,

  mastercard,
  maestro,
  americanExpress,
  visa,
  paypal,

  ResendEmailLoader,

  plan_0,
  plan_1,
  plan_2,
  plan_3,

  plan_basic,
  plan_standard,
  plan_premium,

  heartRed,
  heartBlue,
};
